import {Inject, Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {SESSION_STORAGE, StorageService} from "ngx-webstorage-service";
import {HttpEventService} from "src/app/services/http/http-event.service";
import {combineLatest, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {UserService} from "src/app/services/user.service";
import {IvyMastheadMainMenu} from "@crs/ivy";
import {StoreManagerService} from "../storage.service";

@Injectable()
export class HeaderService {

	constructor(
		private translate: TranslateService,
		public httpEventService: HttpEventService,
		private userService: UserService,
		private storeManagerService: StoreManagerService,
		@Inject(SESSION_STORAGE) private storage: StorageService
	) {
		this.translate.use(translate.getBrowserLang() || 'en');
	}

	shouldDisplay(c: any, userPrivileges: any, role: any) {
		const applyCondition = (a: boolean, b: boolean) => c.userCondition[0](a, b);
		return !((!c.privilege?.every((val: string) => userPrivileges.includes(val)) && c.privilege)
			|| !applyCondition(role.isInternalUser, role.isTenant)
			|| c.excludeRoles?.includes(this.userService.getUserType()));

	}

	getMenuItems(client?: any): Observable<IvyMastheadMainMenu> {
		return combineLatest([
			this.translate.get("masthead.home"),
			this.translate.get("masthead.org_mng"),
			this.translate.get("masthead.file_mng"),
			this.translate.get("masthead.tenant_mng"),
			this.translate.get("masthead.context_mng"),
			this.translate.get("masthead.po_config"),
			this.translate.get("masthead.sys_mng"),
			this.translate.get("masthead.kfk_conn_mgr"),
			this.translate.get("masthead.Opr_mgr"),
			this.userService.userPrivileges$,
			this.userService.clientRole$,
			this.storeManagerService.org$
		]).pipe(
			map(
				([home, org_mng, file_mng, tenant_mng, context_mng, po_config, sys_mng, kfk_conn_mgr, Opr_mgr, userPrivileges, role, org
				 ]) => {
					const itemsArray = [];
					const menuItems: { [key: string]: any } = {
						home: {text: home, ariaLabel: home, routerLink: [""]},
						org_mng: {text: org_mng, ariaLabel: org_mng, routerLink: ["./organization"]},
						file_mng: {text: file_mng, ariaLabel: file_mng, routerLink: ["./files"]},
						tenant_mng: {text: tenant_mng, ariaLabel: tenant_mng, routerLink: ["./tenants"]},
						context_mng: {text: context_mng, ariaLabel: context_mng, routerLink: ["./contextManagement"]},
						po_config: {text: po_config, ariaLabel: po_config, routerLink: ["./poConfig"]},
						sys_mng: {
							text: sys_mng,
							items: [
								{text: kfk_conn_mgr, ariaLabel: kfk_conn_mgr, routerLink: ["./systemManager"]},
								{text: Opr_mgr, ariaLabel: Opr_mgr, routerLink: ["./systemManager/operationsManager"]},
							],
						}
					}

					const conditions: { [key: string]: any } = {
						home: {
							privilege: ['FILEOPS_MANAGEMENT_VIEW'],
							userCondition: [(a: boolean, b: boolean) => !a && !b]
						},
						org_mng: {
							privilege: ['CLIENT_MANAGEMENT_VIEW'],
							userCondition: [(a: boolean, b: boolean) => true]
						},
						file_mng: {
							privilege: ['FILEOPS_MANAGEMENT_VIEW'],
							userCondition: [(a: boolean, b: boolean) => a || b]
						},
						tenant_mng: {
							privilege: ['TENANT_MANAGEMENT_VIEW'],
							userCondition: [(a: boolean, b: boolean) => true]
						},
						context_mng: {
							userCondition: [(a: boolean, b: boolean) => a]
						},
						po_config: {
							privilege: ['PO_CONFIG_VIEW'],
							userCondition: [(a: boolean, b: boolean) => true]
						},
						sys_mng: {
							userCondition: [(a: boolean, b: boolean) => a],
							excludeRoles: ['PS', 'PO']
						}
					};
					if (org === null) {
						if (!(role.isTenant) && !this.storage.get("shortName") && (role.isInternalUser && !this.storage.get("org"))) {
							menuItems.file_mng.ariaLabel = "true";
						}
						if (!this.storage.get("shortName") && !this.storage.get("org")) {
							menuItems.po_config.ariaLabel = "true";
						}
						const status = this.storage.get("userStatus");
						if (status?.id === 2) {
							menuItems.file_mng.ariaLabel = "true";
						}
					} else {
						menuItems.file_mng.ariaLabel = "false";
						if (client?.service?.serviceId === 2) {
							menuItems.po_config.ariaLabel = "false";
						} else {
							// tslint:disable-next-line:indent
							menuItems.po_config.ariaLabel = "true";
						}
					}
					//menuItems.po_config.ariaLabel = "true";// to be removed after integrating PO config

					for (var i in menuItems) {
						if (this.shouldDisplay(conditions[i], userPrivileges, role)) {
							itemsArray.push(menuItems[i])
						}
					}

					return {
						ariaLabel: home,
						items: itemsArray,
					};
				}
			)
		)
	}
}
